<template>
  <c-box>
    <mobile-tab-menu
      v-chakra
      :d="{ lg: 'none' }"
      :mt="{ base: '3xl', sm: '4xl' }"
      :mb="{ base: 'md', sm: 'lg' }"
      :currentPage="`${currentStep}. ${currentPageTitle}`"
      data-cy="wizard-tab-mobile"
    >
      <template>
        <return-tabs
          :currentStep="currentStep"
          :tabData="tabData"
          v-chakra="{
            '& div': {
              display: 'block',
            },
          }"
        />
      </template>
    </mobile-tab-menu>

    <c-box :display="{ base: 'none', lg: 'block' }" data-cy="wizard-tab">
      <return-tabs :currentStep="currentStep" :tabData="tabData" />
    </c-box>
  </c-box>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { CBox } from "@chakra-ui/vue";
import ReturnTabs from "./ReturnTabs.vue";

import MobileTabMenu from "@/components/MobileTabMenu.vue";

export default defineComponent({
  name: "ReturnTabContainer",
  components: {
    CBox,
    ReturnTabs,
    MobileTabMenu,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    tabData: {
      type: Array as PropType<any>,
      required: true,
    },
    currentPageTitle: {
      type: String,
    },
  },
});
</script>
